import { useSearchItemsCache } from "@/stores/search-items-cache";
import { useSnackbarStore } from "@/stores/snackbar";
import { parseErrorMessage } from "@/util/helpers";
import { computed, ref, watch } from "vue";

export function useFileExtensions(initialType) {
  const state = ref({
    acceptedExtensions: "",
    type: initialType
  });

  const cache = useSearchItemsCache();
  const snackbar = useSnackbarStore();

  const items = computed(
    () =>
      cache.documentExtensions.items.find(k => k.key === state.value.type)
        ?.value
  );
  const accepts = computed(() => state.value.acceptedExtensions);
  const loading = computed(() => cache.documentExtensions.loading);

  function setType(v) {
    state.value.type = v;
  }

  async function fetchExtensions() {
    try {
      await cache.getDocumentExtensions();

      state.value.acceptedExtensions = items.value
        ?.map(a => `.${a}`)
        .join(", ");
    } catch (e) {
      snackbar.showErrorSnackbar({ message: parseErrorMessage(e) });
    }

    if (!state.value.acceptedExtensions.length) throw "No defined extensions";
  }

  function validateFiles(files) {
    const acceptableExtensions = items.value.filter(Boolean);

    return files.filter(val => {
      const split = val.name.toLowerCase().split(".").filter(Boolean);
      if (split.length === 1) return false;
      const extension = split[split.length - 1].trim().toLowerCase();
      const isValid = acceptableExtensions.some(
        v => v.trim().localeCompare(extension) === 0
      );

      return isValid;
    });
  }

  watch(() => state.value.type, fetchExtensions, { immediate: true });

  return { accepts, loading, setType, validateFiles };
}
